import Vue from 'vue';
import { rehydrate } from 'overmind';
import { AnswerSurveyStatus, PlanInformationStatus, RescueVoucherStatus, ShowOnBoardingModalStatus, SurveyQuestionStatus, UsersListStatus, } from './state';
import { getCreditsResult } from '@/shared/utils/helpers';
import { mixpanelUpdateUserCreditsConsumption, } from '@/services/mixpanel';
import { NotificationService } from '@/services/NotificationService';
export const getUserCreditsInformation = async ({ effects, }) => {
    const res = await effects.users.usersApi.getUserInformation();
    if (res && res.status == 200 && res.data) {
        return res.data;
    }
};
//GET USER INFORMATION
export const getUserInformation = async ({ state, effects, actions, }) => {
    //@ts-ignore
    actions.users.setPlanInformationStatus(PlanInformationStatus.FETCHING);
    state.users.statusResponse = {};
    const res = await effects.users.usersApi.getUserInformation();
    if (res.status === 200 || res.status === 201) {
        const credits = res.data.credits;
        //@ts-ignore
        actions.users.setPlanInformation(res.account);
        //@ts-ignore
        actions.users.setCreditsAvailable(credits);
        //@ts-ignore
        actions.users.setPlanInformationStatus(PlanInformationStatus.FETCH_SUCCESS);
    }
    else if (res.response.status === 401) {
        //@ts-ignore
        actions.users.setPlanInformationStatus(PlanInformationStatus.FETCH_ERROR);
        state.users.statusResponse = {
            type: 'No authorize',
            //@ts-ignore
            code: res.response.status,
            message: 'No authorize',
        };
    }
    else if (res.response.status === 404) {
        //@ts-ignore
        actions.users.setPlanInformationStatus(PlanInformationStatus.NOT_FOUND);
        state.users.statusResponse = {
            type: 'User information',
            code: 404,
            message: 'No Found',
        };
    }
};
export const setPlanInformationStatus = ({ state: { users: state } }, status) => {
    state.planInformationStatus = status;
};
export const setCreditsAvailable = ({ state }, credits) => {
    state.users.credits = credits;
};
//GET USER ME
export const getUserMe = async ({ state, effects, actions, }) => {
    try {
        const result = await effects.users.usersApi.getUserMe();
        if (result.status &&
            result.status === 200 &&
            result.data &&
            result.data.data) {
            const attributes = result.data.data.attributes;
            const emailUser = attributes.email.split('@');
            state.users.currentUserName = attributes.name;
            state.users.userLoggedRole = attributes.role || '';
            state.users.currentUserEmail = attributes.email;
            state.users.subDomainEmailUser = emailUser[1];
            state.users.have_password = attributes.have_password;
            actions.users.setLocalStorageUserPlanInformation();
            const currentUser = {
                id: result.data.id,
                account_id: attributes.account_id,
                onboardingRememberMe: attributes.onboarding_remember_me,
                name: attributes.name,
                email: attributes.email,
                role: attributes.role,
                featureGroup: attributes.feature_group,
                userInFirstMonth: attributes.user_in_first_month,
                hasOnboarding: attributes.has_onboarding,
                csEmail: attributes.account_cs ? attributes.account_cs.cs_email : '',
                csAvatarUrl: attributes.account_cs
                    ? attributes.account_cs.cs_avatar
                    : '',
                accountType: attributes.account_type,
                origin: attributes.account_origin ? attributes.account_origin : '',
                features: attributes.features || [],
                customer_id: attributes.customer_id,
                superlogica_id: attributes.superlogica_id,
                csgpt: attributes.csgpt,
                canReactivate: attributes.can_reactivate,
                sharableAccessToken: attributes.sharable_access_token,
                showSpeedmailApp: attributes.show_speedmail_app,
                bannerGoalAchievement: attributes.banner_goal_achievement,
            };
            //@ts-ignore
            actions.users.setCurrentUser(currentUser);
        }
    }
    catch (error) {
        console.log(error);
    }
};
export const getUserMeByToken = async ({ state, effects, }) => {
    const result = await effects.users.usersApi.getUserMe();
    if (result.status === 200 && result.data && result.data.data)
        return result;
};
export const setLocalStorageUserPlanInformation = ({ state: { users: state }, }) => {
    localStorage.setItem('user_name_logged', state.currentUserName);
    localStorage.setItem('sub_domain_user_logged', state.subDomainEmailUser);
    localStorage.setItem('user_role_logged', state.userLoggedRole);
    if (state.planInformation) {
        localStorage.setItem('user_plan_name', state.planInformation.planName);
        //@ts-ignore
        localStorage.setItem('end_date_plan_user', state.planInformation.createdAt);
    }
};
export const getBasicLoginInformation = async ({ state: { users: state }, effects, }) => {
    const result = await effects.users.usersApi.getBasicLoginInformation();
    if (result && result.status == 200) {
        state.accountInformation = {
            firstDayUse: result.data.first_day_use,
            firstWeekUse: result.data.first_week_use,
            freeAccount: result.data.free_account,
        };
    }
};
export const ActiveConfig = async ({ state, effects, actions }, { value }) => {
    if (value === true) {
        state.users.configActive = true;
    } // } else {
    //   state.users.configActive = false;
    // }
};
export const setAllUsers = ({ state }, UserPayload) => {
    state.users.users = UserPayload;
};
export const filterUserManaged = ({ state }, string) => {
    state.users.users = state.users.users.filter((item) => {
        return item.attributes.name.toLowerCase().match(string.toLowerCase());
    });
};
export const setPlanInformation = ({ state }, planInformation) => {
    state.users.planInformation = planInformation;
};
// //GET USER GERENCIADOR
export const getSubUsers = async ({ state: { users: state }, effects: { users: effects }, actions: { users: actions }, }, params) => {
    state.statusResponse = {};
    state.users = [];
    //@ts-ignore
    actions.setGetUsersStatus(UsersListStatus.FETCHING);
    const result = await effects.usersApi.getSubUsers(params);
    if (result) {
        if (result.status === 200 && result.data) {
            if (result.data.data && Array.isArray(result.data.data)) {
                //@ts-ignore
                actions.setSubUsers([...result.data.data]);
                state.totalSubUsers =
                    result.data.meta && result.data.meta.total
                        ? result.data.meta.total
                        : 0;
                //@ts-ignore
                actions.setGetUsersStatus(UsersListStatus.RECEIVED);
            }
        }
        else if (result.response.status === 401) {
            //@ts-ignore
            actions.setGetUsersStatus(UsersListStatus.ERROR);
            //@ts-ignore
            actions.setUserStatusResponse({
                type: 'No authorize',
                code: result.response.status,
                message: 'No authorize',
            });
            NotificationService.error('Erro', 'Você não possuí permissão para esta ação!');
        }
        else if (result.response.status === 404) {
            //@ts-ignore
            actions.setGetUsersStatus(UsersListStatus.NOT_FOUND);
            //@ts-ignore
            actions.setUserStatusResponse({
                type: 'No found',
                code: 404,
                message: 'No found',
            });
            state.users = [];
        }
    }
};
export const setGetUsersStatus = ({ state: { users: state } }, value) => {
    state.listUsersStatus = value;
};
// POST USER GERENCIADOR
export const createUsers = async ({ state: { users: state }, effects: { users: effects }, actions: { users: actions }, }, subUser) => {
    state.statusResponse = {};
    const result = await effects.usersApi.createUser(subUser);
    if (result.status === 201) {
        //@ts-ignore
        actions.setUserStatusResponse({
            type: 'create-user',
            code: result.status,
            message: 'Susscesfully',
        });
        NotificationService.success('Sucesso', 'Usuário criado com sucesso');
    }
    else if (result.response.status === 401) {
        //@ts-ignore
        actions.setUserStatusResponse({
            type: 'No authorize',
            code: result.response.status,
            message: 'No authorize',
        });
        NotificationService.error('Erro', 'Você não possuí permissão para esta ação!');
    }
    else if (result.response.status === 422) {
        //@ts-ignore
        actions.setUserStatusResponse({
            type: 'create-user',
            code: result.response.status,
            message: 'The email is aready exist',
        });
    }
    return result;
};
export const answerSurvey = async ({ state: { users: state }, effects: { users: effects } }, survey) => {
    state.answerSurveyStatus = AnswerSurveyStatus.IDLE;
    const result = await effects.usersApi.answerSurvey(survey);
    if (result && result.status === 201) {
        state.answerSurveyStatus = AnswerSurveyStatus.CREATED;
        state.surveyInformation = result.data.data.attributes;
        NotificationService.success('Sucesso', 'Avaliação salva com sucesso!');
    }
    else {
        state.answerSurveyStatus = AnswerSurveyStatus.ERROR;
        NotificationService.error('Erro', 'Aconteceu algo inesperado e não foi possível salvar sua avaliação, por favor tente mais tarde');
    }
};
export const getAllSurveysQuestions = async ({ state: { users: state }, effects: { users: effects }, }) => {
    const result = await effects.usersApi.getAllSurveyQuestions();
    if (result && result.status === 200 && result.data) {
        if (result.data.length > 0) {
            state.surveyQuestionStatus = SurveyQuestionStatus.RECEIVED;
            state.surveyQuestion = result.data;
        }
    }
    else {
        state.surveyQuestionStatus = SurveyQuestionStatus.ERROR;
    }
};
export const setSurveyQuestionStatus = ({ state: { users: state } }, status) => {
    state.surveyQuestionStatus = status;
};
export const createAttemptsLog = async ({ effects: { users: effects }, state: { users: state } }, type) => {
    const result = await effects.usersApi.createAttemptsLog({ type });
    if (result) {
        state.createAttemptsLogStatus = {
            actionType: type,
            success: true,
        }; //@ts-ignore
    }
    else {
        //@ts-ignore
        state.createAttemptsLogStatus = {
            actionType: type,
            success: false,
        };
    }
};
export const getShowSurveyModal = async ({ effects: { users: effects }, state: { users: state }, }) => {
    const result = await effects.usersApi.showSurveyModal();
    if (result && result.status === 200) {
        state.showSurveyModal = result.data.check_permission_to_show_survey;
    }
};
// PATCH USER GERENCIADOR
export const updateUser = async ({ state: { users: state }, effects: { users: effects }, actions: { users: actions }, }, payload) => {
    state.statusResponse = {};
    const result = await effects.usersApi.updateUser(payload.id, payload);
    if (result && result.status === 200) {
        //@ts-ignore
        actions.setUserStatusResponse({
            type: 'edit-user',
            code: result.status,
            message: 'Susscesfully',
        });
        NotificationService.success('Sucesso', 'Usuário editado com sucesso');
    }
    else if (result && result.response.status === 401) {
        //@ts-ignore
        actions.setUserStatusResponse({
            type: 'No authorize',
            code: result.response.status,
            message: 'No authorize',
        });
        NotificationService.error('Erro', 'Você não possuí permissão para esta ação!');
    }
    else if (result && result.response.status === 422) {
        //@ts-ignore
        actions.setUserStatusResponse({
            type: 'edit-user',
            code: result.response.status,
            message: 'The email is aready exist',
        });
    }
    return result;
};
// //DELETED USER GERENCIADOR
export const removeUser = async ({ effects: { users: effects }, actions: { users: actions } }, { userId }) => {
    const result = await effects.usersApi.removeUser(userId);
    if (result && result.status === 200) {
        //@ts-ignore
        actions.setUserStatusResponse({
            type: 'delete-user',
            code: result.status,
            message: 'Succesfully',
        });
        NotificationService.success('Sucesso', 'Usuário deletado com sucesso');
    }
    else if (result && result.response.status === 401) {
        //@ts-ignore
        actions.setUserStatusResponse({
            type: 'No authorize',
            code: result.response.status,
            message: 'No authorize',
        });
        NotificationService.error('Erro', 'Você não possuí permissão para esta ação!');
    }
    return result;
};
export const setCurrentUser = ({ state: { users: state } }, user) => {
    state.currentUser = user;
};
export const setSubUsers = ({ state: { users: state } }, subUsers) => {
    state.users = subUsers;
};
export const removeSubUsers = ({ state: { users: state } }, index) => {
    state.users.splice(index, 1);
};
export const setUserStatusResponse = ({ state: { users: state } }, { code, message, type }) => {
    state.statusResponse = { type, code, message };
};
//RESET PASSWORD
export const resetPassword = async ({ state, effects }, { email }) => {
    state.users.statusResponse = {};
    const payload = { email: email };
    return await effects.users.usersApi.resetPassword(payload);
};
//PATCH USER INFORMATION
export const changePassword = async ({ effects }, { create_password, old_password, password, password_confirmation }) => {
    const payload = {
        create_password: create_password,
        old_password: old_password,
        password: password,
        password_confirmation: password_confirmation,
    };
    return await effects.users.usersApi.changePassword(payload);
};
//SET UPDATED PERCENT PIPEDRIVE
export const setPipedriveUploadPercent = async ({ state: { users: state } }, { companies, company }) => {
    const totalPercentValue = company / companies;
    state.countCompaniesSendedToPipedrive = totalPercentValue;
};
//UPDATED LABEL PERCENT PIPEDRIVE
export const setPipedriveLabelPercent = async ({ state: { users: state } }, { companies, company }) => {
    let percentLabel = ((company / companies) * 100).toFixed(2);
    percentLabel = `${percentLabel} %`;
    state.totalPercentLabelPipedrive = percentLabel;
};
export const exportToTvs = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToToTvs({
        infosetId,
        payload,
    });
};
export const exportPipedrive = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToPipedrive({
        infosetId,
        payload,
    });
};
export const exportAgendor = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToAgendor({
        infosetId,
        payload,
    });
};
export const exportPiperun = async ({ effects }, { infosetId, payload, onlyValidPhones, dealConfig }) => {
    return await effects.users.usersApi.exportToPiperun({
        infosetId,
        payload,
        onlyValidPhones,
        dealConfig,
    });
};
export const exportFunilDeVendas = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToFunilDeVendas({
        infosetId,
        payload,
    });
};
export const exportSalesForce = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToSalesForce({
        infosetId,
        payload,
    });
};
export const exportPloomes = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToPloomes({
        infosetId,
        payload,
    });
};
export const exportRDStation = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToRDStation({
        infosetId,
        payload,
    });
};
export const exportHubspot = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToHubspot({ infosetId, payload });
};
export const exportZoho = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToZoho({
        infosetId,
        payload,
    });
};
export const exportMeetime = async ({ effects }, { infosetId, payload, cadenceConfig, onlyValidPhones }) => {
    const cadenceId = cadenceConfig && cadenceConfig.cadence;
    if (!cadenceId) {
        NotificationService.error('Erro', 'Selecione uma cadência');
        return;
    }
    const ownerEmail = cadenceConfig && cadenceConfig.owner;
    if (!ownerEmail) {
        NotificationService.error('Erro', 'Selecione um responsável');
        return;
    }
    return await effects.users.usersApi.exportToMeetime({
        infosetId,
        payload,
        cadenceId,
        ownerEmail,
        onlyValidPhones,
    });
};
export const exportBitrix24 = async ({ effects }, { infosetId, payload }) => {
    return await effects.users.usersApi.exportToBitrix24({
        infosetId,
        payload,
    });
};
//SET TOKEN PLOOMES IN STATE
export const setKeysFieldPloomes = ({ state: { users: state } }, payload) => {
    const field = state.keysContactsPloomes.filter(field => field.Name === payload.Name);
    if (field.length === 0) {
        state.keysContactsPloomes = [...state.keysContactsPloomes, payload];
    }
};
//SET KEY OBJECTS IN STATE
export const setKeysObjectsContactsPloomes = ({ state: { users: state } }, { key, name }) => {
    state.objectKeyContactPloomes[`${key}`] = name;
};
export const recoverPassword = async ({ state, effects }, { action_token, password, password_confirmation }) => {
    state.users.statusResponse = {};
    const payload = {
        action_token: action_token,
        password: password,
        password_confirmation: password_confirmation,
    };
    return await effects.users.usersApi.recoverPassword(payload);
};
export const verifyOtp = async ({ effects }, payload) => {
    return await effects.users.usersApi.verifyOtp(payload);
};
export const getNotifications = async ({ state: { users: state }, effects: { users: effects }, actions: { users: actions }, }, { page }) => {
    // @ts-ignore
    const userId = state.currentUser ? state.currentUser.id : Vue.auth.user().id;
    const result = await effects.usersApi.getNotifications(userId, page);
    if (result) {
        if (result.data && Array.isArray(result.data)) {
            const resultSerializer = result.data.map(data => ({
                ...data,
                _id: data._id.$oid,
                user_id: data.user_id.$oid,
                account_id: data.account_id.$oid,
            })); //@ts-ignore
            actions.updateIgnoredNotifications(); //@ts-ignore
            actions.setNotifications(resultSerializer); //@ts-ignore
            actions.verifyNewNotifications();
        }
    }
};
//UPDATE NOTIFICATIONS LOCALLY
export const updateLocalNotifications = ({ state: { users: state }, actions: { users: actions }, }) => {
    const notifications = JSON.parse(localStorage.newNotifications || '[]');
    localStorage.setItem('newNotifications', JSON.stringify([
        ...notifications,
        ...state.notifications
            .map(res => res._id)
            .filter(n => !notifications.includes(n)),
    ]));
};
//ADD IGNORED NOTIFICATIONS LOCALLY
export const addLocalIgnoredNotifications = ({ state, actions: { users: actions } }, notification) => {
    const ignoredNotifications = JSON.parse(localStorage.ignoredNotifications || '[]');
    ignoredNotifications.push(notification._id);
    localStorage.setItem('ignoredNotifications', JSON.stringify(ignoredNotifications)); //@ts-ignore
    actions.addIgnoredNotification(notification);
};
export const addIgnoredNotification = ({ state: { users: state } }, notification) => {
    state.ignoredNotifications.push(notification._id);
};
//UPDATE IGNORED NOTIFICATIONS LOCALLY
export const updateIgnoredNotifications = ({ state: { users: state }, }) => {
    const ignoredNotifications = JSON.parse(localStorage.ignoredNotifications || '[]');
    const notifications = ignoredNotifications.filter(n => !state.ignoredNotifications.includes(n));
    state.ignoredNotifications = [...state.ignoredNotifications, ...notifications];
};
export const verifyNewNotifications = ({ state: { users: state }, actions: { users: actions }, }) => {
    const { notifications } = state;
    const localNotifications = JSON.parse(localStorage.newNotifications || '[]');
    /* const verify = notifications.every(notification =>
      localNotifications.includes(notification._id)
    ); */
    const haveNewNotifications = notifications.length > 0
        ? !localNotifications.includes(notifications[0]._id)
        : false;
    state.haveNewNotifications = haveNewNotifications;
};
export const setNotifications = ({ state: { users: state }, actions: { users: actions } }, notifications) => {
    //@ts-ignore
    const newNotifications = actions.unrepeatedNotifications(notifications);
    state.notifications =
        //@ts-ignore
        actions.getSortNotificationsByCreatedAt(newNotifications);
};
export const getSortNotificationsByCreatedAt = ({}, notifications) => {
    return notifications.sort((a, b) => a.created_at < b.created_at ? 1 : a.created_at > b.created_at ? -1 : 0);
};
export const unrepeatedNotifications = ({ state: { users: state } }, notifications) => {
    const notificationsIds = state.notifications.map(n => n._id);
    const newNotifications = notifications.filter(notification => !notificationsIds.includes(notification._id));
    return [...state.notifications, ...newNotifications];
};
export const addNotification = ({ state }, notification) => {
    if (state.users.notifications) {
        state.users.notifications.push(notification);
    }
    else {
        state.users.notifications = [notification];
    }
};
export const editNotification = ({ state: { users: state } }, notification) => {
    const indexNotification = state.notifications.findIndex(n => n._id === notification._id);
    if (indexNotification > -1) {
        state.notifications[indexNotification] = notification;
    }
};
export const markNotificationsAsRead = async ({ state: { users: state }, effects: { users: effects }, actions: { users: actions }, }, notification) => {
    try {
        const userId = state.currentUser
            ? state.currentUser.id
            : // @ts-ignore
                // @ts-ignore
                Vue.auth.user().id;
        await effects.usersApi.markNotificationsAsRead(userId, notification._id); //@ts-ignore
        actions.editNotification({ ...notification, read: true });
    }
    catch (error) {
        console.error(error);
    }
};
//Action to clean accessToken in state
export const logoutCleanToken = async ({ state }) => {
    state.users.accessToken = null;
};
export const cleanStoreUsers = ({ state }) => {
    rehydrate(state, {
        users: {
            users: [],
            planInformation: {},
            password: '',
            statusOk: false,
            statusError: false,
            currentUserCreated: {},
            accessToken: null,
            currentUserName: '',
            statusResponse: {},
            userLoggedRole: '',
            subDomainEmailUser: '',
            currentUser: null,
        },
    });
};
export const setHasUpdate = ({ state: { users: state } }, value) => {
    state.hasUpdate = value;
};
export const showOnBoardingModal = async ({ state: { users: state }, effects: { users: effects }, actions: { users: actions }, }) => {
    const result = await effects.usersApi.showOnBoardingModal();
    //@ts-ignore
    actions.setShowOnBoardingModalStatus(ShowOnBoardingModalStatus.FETCHING);
    if (state.currentUser && !state.currentUser.onboardingRememberMe)
        localStorage.removeItem('onboarding_remeber_me_later');
    if (result && result.status === 200) {
        //@ts-ignore
        actions.setShowOnBoardingModalStatus(ShowOnBoardingModalStatus.RECEIVED);
        state.showOnBoardingModal = result.data.check_permission_to_show_onboarding;
    }
    else if (result && result.status === 404) {
        //@ts-ignore
        actions.setShowOnBoardingModalStatus(ShowOnBoardingModalStatus.NOT_FOUND);
    }
    else {
        //@ts-ignore
        actions.setShowOnBoardingModalStatus(ShowOnBoardingModalStatus.ERROR);
    }
};
export const showVoucher = async ({ state: { users: state }, effects: { users: effects }, }) => {
    const result = await effects.usersApi.handleVoucherVisibility();
    if (result && result.status === 200) {
        state.showVoucher = result.data.check_permission_to_show_voucher;
    }
    else {
        state.showVoucher = false;
    }
};
export const rescueVoucher = async ({ effects: { users: effects }, state: { users: state }, actions: { users: actions }, }, { allowedVoucher, voucherAction, surveyId }) => {
    const result = await effects.usersApi.rescueVoucher({
        allowedVoucher,
        voucherAction,
        surveyId,
    });
    if (result && result.status === 201 && result.data) {
        //@ts-ignore
        actions.setRescueVoucherStatus(RescueVoucherStatus.FINISHED);
    }
    else {
        //@ts-ignore
        actions.setRescueVoucherStatus(RescueVoucherStatus.ERROR);
    }
};
export const setRescueVoucherStatus = ({ state: { users: state } }, value) => {
    state.rescueVoucherStatus = value;
};
export const setShowOnBoardingModalStatus = ({ state: { users: state } }, value) => {
    state.showOnBoardingModalStatus = value;
};
export const onboardingRegister = async ({ effects: { users: effects }, state: { users: state } }, { comment, selectedOption, emailUser, responsibleSelectedCsMember, creationOfOnboardingByAdmin, }) => {
    const result = await effects.usersApi.onboardingRegister({
        comment,
        selectedOption,
        emailUser,
        responsibleSelectedCsMember,
        creationOfOnboardingByAdmin,
    });
    if (result && result.status === 201) {
        NotificationService.success('Sucesso', 'Onboarding resgistrado com sucesso!');
        state.statusOnBoarding = result.data.status_onboarding;
        localStorage.removeItem('onboarding_remember_me_later');
    }
};
export const rememberMeLater = async ({ effects: { users: effects }, state: { users: state } }, onboarding_update) => {
    const result = await effects.usersApi.rememberMeLater({
        user_id: state.currentUser.id,
        onboarding_update,
    });
    if (result && result.status === 201) {
        localStorage.setItem('onboarding_remember_me_later', new Date().toISOString());
        if (result.data && result.data.data && result.data.data.attributes) {
            state.currentUser.onboardingRememberMe =
                result.data.data.attributes.onboarding_remember_me;
        }
    }
};
export const recoverExportationFieldsAndFilters = async ({ effects: { users: effecs } }) => {
    const result = await effecs.usersApi.getExportationFieldsAndFilters();
    if (result && result.status >= 200 && result.status < 300) {
        return result.data;
    }
};
export const saveExportationFieldsAndFilters = async ({ effects: { users: effecs } }, config) => {
    await effecs.usersApi.saveExportationFieldsAndFilters(config);
};
export const deleteExportationFieldsAndFiltersSaved = async ({ effects: { users: effecs }, state: { users: state } }) => {
    // @ts-ignore
    const userId = state.currentUser ? state.currentUser.id : Vue.auth.user().id;
    await effecs.usersApi.deleteExportationFieldsAndFiltersSaved(userId);
};
export const getAccountId = async ({ state: { users: state }, actions }) => {
    if (state.planInformation._id.length == 0)
        await actions.users.getUserInformation();
    const account_id = state.planInformation._id;
    return account_id;
};
export const getUserAccountPreferences = async ({ effects: { users: effect }, }) => {
    const res = effect.usersApi.getUserAccountPreferences();
    return res;
};
export const setUserAccountPreferences = async ({ effects: { users: effect } }, data) => {
    const res = effect.usersApi.setUserAccountPreferences(data);
    return res;
};
export const getUserRefreshToken = async ({ effects: { users: effects } }, userToken) => {
    const new_token = await effects.usersApi.getUserRefreshToken(userToken);
    if (new_token && new_token.status && new_token.status == 200)
        return new_token;
    else
        return false;
};
export const addCreateListAutomaticEvent = async ({ effects: { users: effects }, }) => {
    const result = await effects.usersApi.addCreateListAutomaticEvent();
    if (result && result.status === 201)
        return result;
    else
        return false;
};
export const getCreateListAutomaticEvent = async ({ effects: { users: effects }, state, }) => {
    const result = await effects.usersApi.getCreateListAutomaticEvent();
    if (result && result.status === 200) {
        state.search.createAutomaticEventExist = result.data.value;
        return result;
    }
    else
        return false;
};
export const updateAccountCredits = async ({ state: { users: state } }, data) => {
    state.accountCredits = data;
    if (state.accountCredits &&
        state.accountCredits.clicks &&
        state.accountCredits.export) {
        const infos = {
            consult_consumption: state.accountCredits.clicks.percentage
                ? state.accountCredits.clicks.percentage
                : 0,
            export_consumption: state.accountCredits.export.percentage
                ? state.accountCredits.export.percentage
                : 0,
        };
        mixpanelUpdateUserCreditsConsumption(infos);
    }
};
export const getUserCreditsPercentage = async ({ actions }) => {
    const result = await actions.users.getUserCreditsInformation();
    if (result) {
        const userCredits = { ...result.credits } || {};
        const getClickPercentage = getCreditsResult(userCredits, 'click');
        const getExportPercentage = getCreditsResult(userCredits, 'export');
        const data = {
            clicks: getClickPercentage,
            export: getExportPercentage,
        };
        return data;
    }
};
export const tryCreateNewAccount = async ({ effects: { users: effects } }, data) => {
    const request = await effects.usersApi.tryCreateNewAccount(data);
    return request;
};
export const tryCreateAuthToken = async ({ effects: { users: effects } }, data) => {
    const request = await effects.usersApi.tryCreateAuthToken(data);
    return request;
};
export const tryAuthLogin = async ({ effects: { users: effects } }, data) => {
    const request = await effects.usersApi.tryAuthLogin(data);
    return request;
};
export const createAccountWithSocialMedia = async ({ effects: { users: effects } }, data) => {
    const request = await effects.usersApi.createAccountWithSocialMedia(data);
    return request;
};
export const getUserExists = async ({ effects: { users: effects }, state }, data) => {
    const request = await effects.usersApi.getUserExists(data);
    return request;
};
export const getReferralList = async ({ effects: { users: effects } }) => {
    const getReferral = await effects.usersApi.getReferralList();
    return getReferral;
};
export const getReferralLink = async ({ effects: { users: effects } }) => {
    const getReferral = await effects.usersApi.getReferralLink();
    return getReferral;
};
export const getAuthPermissions = () => {
    //@ts-ignore
    const user = Vue.auth.user();
    if (user) {
        const speedioUser = user.email.includes('@speedio');
        const originBypass = ['closers', 'Conta Teste'];
        const campaignBypass = ['totvs'];
        const userOriginBypass = !user.origin || originBypass.includes(user.origin);
        const userCampaignBypass = campaignBypass.includes(user.campaign) || false;
        const userFree = !user.accountType ||
            user.accountType == 'free' ||
            user.accountType == 'undefined';
        return !(!speedioUser &&
            !userOriginBypass &&
            !userCampaignBypass &&
            userFree);
    }
    return 'auth-not-found';
};
export const canOpenExportModal = () => {
    //@ts-ignore
    const user = Vue.auth.user();
    if (!user)
        return false;
    const speedioUser = user.email.includes('@speedio');
    if (speedioUser)
        return true;
    const userOriginBypass = ['closers', 'Conta Teste', null].includes(user.origin) ||
        user.skipOriginCheck == true;
    const userCampaignBypass = ['totvs'].includes(user.campaign);
    const userFree = ['free', 'undefined', null].includes(user.accountType);
    return !userFree || userOriginBypass || userCampaignBypass;
};
export const authenticatedUserToShowWelcomeScreen = () => {
    //@ts-ignore
    const user = Vue.auth.user();
    if (user) {
        const speedioUser = user.email.includes('@speedio');
        return !speedioUser;
    }
    return true;
};
export const sendIncompatibleMobileEmail = async ({ effects: { users: effects }, }) => {
    const request = await effects.usersApi.sendIncompatibleMobileEmail();
    if (request.status == 200) {
        NotificationService.success('Sucesso', 'E-mail enviado com sucesso');
    }
};
export const suggestSpeedmail = async ({ effects, state }) => {
    const res = await effects.users.usersApi.suggestSpeedmail();
};
export const contactSupport = async ({ effects: { users: effects } }) => {
    const request = await effects.usersApi.contactSupport();
    return request;
};
export const getShowHyperbolic = async ({ effects }) => {
    const result = await effects.users.usersApi.getShowHyperbolic();
    return result;
};
export const experienceUserHyperbolic = async ({ effects, state }, data) => {
    const res = await effects.users.usersApi.experienceUserHyperbolic(data);
};
export const tryToRegisterNewAdditionalUser = async ({ effects, state }) => {
    const res = (await effects.users.usersApi.tryToRegisterNewAdditionalUser())
        ? effects.users.usersApi.tryToRegisterNewAdditionalUser()
        : '';
};
export const tryToImportWithoutCredits = async ({ effects, state }) => {
    const res = await effects.users.usersApi.tryToImportWithoutCredits();
};
export const enterSmConfig = async ({ effects, state }) => {
    const res = await effects.users.usersApi.enterSmConfig();
};
export const clickedOnUpgrade = async ({ effects, state }) => {
    const res = await effects.users.usersApi.clickedOnUpgrade();
};
export const scheduledDemo = async ({ effects, state }) => {
    const res = await effects.users.usersApi.scheduledDemo();
    if (!res.data.success)
        return;
    NotificationService.success('Sucesso', 'Um dos nossos consultores entrará em contato com você em breve');
};
export const getDisplayWelcomeScreen = async ({ effects }) => {
    const res = await effects.users.usersApi.displayWelcomeScreen();
    return (res && res.data && res.data.value) || false;
};
export const welcomeScreenSearch = async ({ effects }, data) => {
    const res = await effects.users.usersApi.welcomeScreenSearch(data);
    return res;
};
export const toggleAutoplayActive = async ({ effects }, data) => {
    await effects.users.usersApi.toggleAutoplayActive(data);
};
export const disableAllAutoplay = async ({ effects }) => {
    await effects.users.usersApi.disableAllAutoplay();
};
export const saveAutoplay = async ({ effects }, data) => {
    await effects.users.usersApi.saveAutoplay(data);
};
export const getAutoplay = async ({ effects }, id) => {
    return await effects.users.usersApi.getAutoplay(id);
};
export const saveCrmAutoplay = async ({ effects }, data) => {
    const crm = data.crm;
    const token = data.token;
    await effects.users.usersApi.saveCrmAutoplay(crm, token);
};
export const getCrmAutoplay = async ({ effects }, crm) => {
    const result = await effects.users.usersApi.getCrmAutoplay(crm);
    return result;
};
export const getInfoAutoPlay = async ({ effects }) => {
    return await effects.users.usersApi.getInfoAutoPlay();
};
export const getAnswersWelcomeScreen = async ({ effects }) => {
    const result = await effects.users.usersApi.getAnswersWelcomeScreen();
    return result;
};
export const getDefaultSearch = async ({ effects, state }) => {
    const result = await effects.users.usersApi.getDefaultSearch();
    if (result && result.data && result.data.default_search) {
        state.search.defaultSearch = {
            id: result.data.default_search,
            active: result.data.using_default_search,
        };
        return result;
    }
    state.search.defaultSearch.active = false;
    state.search.defaultSearch.id = '';
    return result;
};
export const updateDefaultSearch = async ({ effects, state }, data) => {
    const result = await effects.users.usersApi.updateDefaultSearch(data);
    state.search.defaultSearch = result.data.data;
    return result.data;
};
export const setIsOnboardingSmallFormFields = ({ state }, value) => {
    state.users.isOnboardingSmallFormFields = value;
};
export const getShowAvaliableAutoplay = async ({ effects }) => {
    const result = await effects.users.usersApi.getShowAvaliableAutoplay();
    return result;
};
export const setWelcomeScreenAnswer = ({ state }, data) => {
    state.users.welcomeScreenAnswer[data.name] = data.value;
};
export const setAutoplay = ({ state: { search: state, users: usersState }, }) => {
    const accountIsActive = ['active', 'suspended', 'migrated'].includes(usersState.currentUser.accountType);
    const autoplayActiveCount = state.histories.filter(history => history.autoplay == true).length;
    if (accountIsActive && autoplayActiveCount > 0)
        state.showAutoPlay = true;
    state.showAutoPlay = true;
};
export const createNewNote = async ({ effects }, data) => {
    const result = await effects.users.usersApi.createNewNote(data);
    if (result) {
        return result;
    }
};
export const deletNote = async ({ effects }, id) => {
    //@ts-ignore
    const result = await effects.users.usersApi.deletNote(id);
    if (result) {
        return result;
    }
};
export const getAllNotes = async ({ effects }, companyId) => {
    //@ts-ignore
    const result = await effects.users.usersApi.getAllNotes(companyId);
    if (result) {
        return result;
    }
};
export const closedWelcomeBackModal = async ({ effects }) => {
    const result = await effects.users.usersApi.closedWelcomeBackModal();
    return result;
};
